module.exports = {
  downloadBlob: (blob, filename) => {
    const blobUrl = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.href = blobUrl
    tempLink.setAttribute('download', filename)
    tempLink.click()
  },
  isRunningOnDev: () => window.location.href.indexOf('dev.') > -1 || window.location.href.indexOf('localhost') > -1
}